import { GTooltip } from 'components/basic-blocks'
import { AiOutlineQuestionCircle } from 'react-icons/ai'
import { GNewWindowedSelect } from 'components/basic-blocks/g-new-virtualized-select'
import { AccountSelectionState } from './types'
import { FilterOptionOption } from 'react-select/dist/declarations/src/filters'

interface PixelOption {
	id: string
	name: string
}

interface PixelDropdownProps {
	accountSelection: AccountSelectionState
	pixelOptions: PixelOption[]
	loading: boolean
	onChange: (pixelId: string | null) => void
}

export const PixelDropdown = ({
	accountSelection,
	pixelOptions,
	loading,
	onChange
}: PixelDropdownProps) => {
	return (
		<div className="flex flex-col gap-[6px]">
			<div className="flex items-center gap-2">
				<label className="text-[14px] leading-[18px] font-medium text-t-default">
					Select a Pixel
				</label>
				<GTooltip
					content="Web ID to be used to track your audience behaviour"
					position="top"
					arrowClassName="w-0 h-0 absolute bottom-[0.5px] border-l-8 border-l-transparent border-r-8 border-r-transparent border-t-8 border-t-tooltip-caret"
					contentClassName="border-none mb-2 bg-t-smoke font-medium text-sm text-t-desc-gray"
				>
					<AiOutlineQuestionCircle className="text-t-gray-hold w-4 h-4" />
				</GTooltip>
			</div>
			<GNewWindowedSelect<PixelOption>
				label=""
				options={pixelOptions || []}
				value={
					accountSelection.pixel_id
						? pixelOptions.find((p) => p.id === accountSelection.pixel_id) ||
						  null
						: null
				}
				isDisabled={loading}
				onChange={(newValue: any) => {
					const pixel = newValue as PixelOption | null
					onChange(pixel?.id || null)
				}}
				placeholder="Select a pixel"
				isOptionSelected={(option) => {
					const opt = option as PixelOption
					return opt?.id === accountSelection.pixel_id
				}}
				formatOptionLabel={(option) => {
					const opt = option as PixelOption
					if (!opt) return ''
					return `${opt.name} (${opt.id})`
				}}
				getOptionLabel={(option) => {
					const opt = option as PixelOption
					if (!opt) return ''
					return `${opt.name} (${opt.id})`
				}}
				filterOption={(option, query) => {
					if (!query) return true
					try {
						const opt = option as FilterOptionOption<PixelOption>
						const pixel = opt?.data
						if (!pixel) return false
						const name = (pixel.name || '').toLowerCase()
						const id = (pixel.id || '').toLowerCase()
						const lowerQuery = query.toLowerCase()
						return name.includes(lowerQuery) || id.includes(lowerQuery)
					} catch (err) {
						console.error('Filter option error:', err)
						return true
					}
				}}
			/>
		</div>
	)
}
